import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=8b1c849c&scoped=true"
import script from "./jobDetail.vue?vue&type=script&lang=js"
export * from "./jobDetail.vue?vue&type=script&lang=js"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=8b1c849c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c849c",
  null
  
)

export default component.exports